export interface CookiesConsentProps {
  date: Date;
}

export const STORAGE = "@SellerAccessCode";

export const get = () => {
  const cookiesConsent = localStorage.getItem(STORAGE);

  return JSON.parse(cookiesConsent as string) as
    | CookiesConsentProps
    | undefined;
};

export const set = (data: CookiesConsentProps) => {
  localStorage.setItem(STORAGE, JSON.stringify(data));
};

export const remove = () => {
  localStorage.removeItem(STORAGE);
};
